import {SagaIterator} from "redux-saga";
import {call, delay, put, select} from "typed-redux-saga";
import {Api, ApiError} from "modules/utils/Api";
import {
	showErrorModal,
	fetchContextualPrompt,
	fetchContextualPromptSuccess,
	fetchContextualPromptError,
	declineContextualPrompt,
	declineContextualPromptSuccess,
	declineContextualPromptError,
	openContextualPrompt,
	closeContextualPrompt,
} from "modules/actions";
import {getLoginPayload} from "modules/selectors";
import {ENVIRONMENT} from "modules/constants";

export const fetchContextualPromptSaga = function* (
	_action: ReturnType<typeof fetchContextualPrompt>
): SagaIterator {
	try {
		const {uid} = yield* select(getLoginPayload);

		const response = yield* call(Api.User.checkContextualPrompt, {uid});

		if (ENVIRONMENT === "uat") {
			console.log(response);
		}
		ApiError.CHECK(response.data);

		yield* put(fetchContextualPromptSuccess(response.data.success.prompt));

		const prompts = [response.data.success.prompt].flatMap((it) => it);

		if (prompts.length) {
			yield* put(openContextualPrompt());
			yield* delay(10000);
			yield* put(closeContextualPrompt());
		}
	} catch (e) {
		const error = e as ApiError;
		yield* put(showErrorModal(error.message));
		yield* put(fetchContextualPromptError());
		yield* put(closeContextualPrompt());
	}
};

export const declineContextualPromptSaga = function* ({
	payload,
}: ReturnType<typeof declineContextualPrompt>): SagaIterator {
	try {
		const response = yield* call(Api.User.declineContextualPrompt, payload);

		ApiError.CHECK(response.data);

		yield* put(declineContextualPromptSuccess(payload));
	} catch (e) {
		const error = e as ApiError;
		yield* put(showErrorModal(error.message));
		yield* put(declineContextualPromptError());
	}
};
